import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";

export function useWorkspaceOperation() {
  const location = useLocation();
  const { businessId, locationId, workspaceReady } = useCurrentBusiness();
  const { getAuthGeneration } = useAuth();
  const current = useRef<{ active: boolean } | null>(null);

  useLayoutEffect(() => {
    const scope = { active: workspaceReady };
    current.current = scope;
    return () => { scope.active = false; };
  }, [location.key, location.pathname, location.search, location.hash, businessId, locationId, workspaceReady]);

  return () => {
    const scope = current.current;
    const generation = getAuthGeneration();
    // Cache updates still belong to their captured business; UI effects belong to this route lifetime.
    return () => !!scope?.active && scope === current.current && generation === getAuthGeneration();
  };
}
